import type { ToggleSwitchPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';

export enum ToggleSize {
  BASE = 'base',
  LARGE = 'large',
}

export type PassThroughMeridiaToggle =
  PassThrough<ToggleSwitchPassThroughOptions> & {
    label?: { class: string };
    wrapper?: { class: string };
  };
